"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var device = {
    TABLET: '768px',
    DESKTOP: '1200px',
};
exports.default = device;
